<mat-form-field class="custom-mat-datepicker">
  <mat-label [appTranslate]="'CHOOSE_DATE'"></mat-label>
  <input [attr.id]="inputId" [attr.name]="inputName" matInput [matDatepicker]="picker" [(ngModel)]="selectedDate" [min]="minDate"
    (dateChange)="onDateChange($event.value)" placeholder="DD.MM.YYYY">
  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>